const config = {
    appName: process.env.REACT_APP_NAME || 'Godzilla',
    apiBaseUrl: process.env.REACT_APP_BASE_API_URL,
};
export default config;
